const INITIAL_STATE = {
  rangeRestrictionList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_RANGE_RESTRICTION': {
      return { ...state, rangeRestrictionList: action.rangeRestrictions };
    }
    default:
      return state;
  }
};
